var map = {
	"./emotion-slow.mp3": 812,
	"./ex1-slow.mp3": 813,
	"./ex1_3_4-slow.mp3": 814,
	"./ex7-slow.mp3": 815,
	"./ex8-slow.mp3": 816,
	"./health-slow.mp3": 817,
	"./life-cycle-slow.mp3": 818,
	"./life-slow.mp3": 819,
	"./recognition-slow.mp3": 821,
	"./view5-ex1-slow.mp3": 822,
	"./view8-ex1-slow.mp3": 823,
	"./view9-ex1-slow.mp3": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 502;